import { create } from 'zustand';

const EMPTY_HEADER = {
  text: '',
  subtitle: undefined,
  subtitleTooltipClassName: undefined,
  children: undefined,
  className: undefined,
  variant: 'default',
  showBack: false,
  backTo: undefined,
  onBack: undefined,
  style: undefined,
  ownerId: null,
};

function isHeaderEmpty(state) {
  return (
    !state.text &&
    state.subtitle === undefined &&
    state.subtitleTooltipClassName === undefined &&
    state.children === undefined &&
    state.className === undefined &&
    state.variant === 'default' &&
    !state.showBack &&
    state.backTo === undefined &&
    state.onBack === undefined &&
    state.style === undefined
  );
}

function headerPayloadEqual(state, payload) {
  return (
    state.text === (payload.text || '') &&
    state.subtitle === payload.subtitle &&
    state.subtitleTooltipClassName === payload.subtitleTooltipClassName &&
    state.children === payload.children &&
    state.className === payload.className &&
    state.variant === (payload.variant || 'default') &&
    state.showBack === Boolean(payload.showBack) &&
    state.backTo === payload.backTo &&
    state.onBack === payload.onBack &&
    state.style === payload.style
  );
}

export const useHeaderStore = create((set) => ({
  ...EMPTY_HEADER,
  setHeader: (
    { text, subtitle, subtitleTooltipClassName, children, className, variant, showBack, backTo, onBack, style },
    ownerId
  ) =>
    set((state) => {
      const next = {
        text: text || '',
        subtitle,
        subtitleTooltipClassName,
        children,
        className,
        variant: variant || 'default',
        showBack: showBack || false,
        backTo,
        onBack,
        style,
        ownerId: ownerId ?? null,
      };
      if (headerPayloadEqual(state, next) && state.ownerId === next.ownerId) {
        return state;
      }
      return next;
    }),
  /** Ne vide le store que si ownerId correspond (évite race au changement de route). */
  clearHeader: (ownerId) =>
    set((state) => {
      if (ownerId != null && state.ownerId !== ownerId) {
        return state;
      }
      if (isHeaderEmpty(state)) {
        return state;
      }
      return { ...EMPTY_HEADER };
    }),
}));
